import { render, staticRenderFns } from "./selectAdminOneCommunity.vue?vue&type=template&id=8f27af12&scoped=true"
import script from "./selectAdminOneCommunity.vue?vue&type=script&lang=js"
export * from "./selectAdminOneCommunity.vue?vue&type=script&lang=js"
import style0 from "./selectAdminOneCommunity.vue?vue&type=style&index=0&id=8f27af12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f27af12",
  null
  
)

export default component.exports